// Resolves app config from local dev env vars first, falling back to the
// checked-in src/config.json (whose #{TOKEN}# placeholders get substituted
// with real values by the deploy pipeline for QA/Prod).
//
// For local dev: `cp .env.example .env.local` and fill in real values -
// .env.local is git-ignored, so src/config.json never needs local edits.
import baseConfig from "./config.json";

const config = {
  KATA_LIFE_API_URL: process.env.REACT_APP_KATA_LIFE_API_URL || baseConfig.KATA_LIFE_API_URL,
  "FEEDBACK-UI-QUESTION-COUNT":
    process.env.REACT_APP_FEEDBACK_UI_QUESTION_COUNT || baseConfig["FEEDBACK-UI-QUESTION-COUNT"],
  "FEEDBACK-UI-SUBMITTED-MESSAGE":
    process.env.REACT_APP_FEEDBACK_UI_SUBMITTED_MESSAGE || baseConfig["FEEDBACK-UI-SUBMITTED-MESSAGE"],
  "FEEDBACK-UI-NOTFOUND-MESSAGE":
    process.env.REACT_APP_FEEDBACK_UI_NOTFOUND_MESSAGE || baseConfig["FEEDBACK-UI-NOTFOUND-MESSAGE"],
  "FEEDBACK-UI-EXPIRED-MESSAGE":
    process.env.REACT_APP_FEEDBACK_UI_EXPIRED_MESSAGE || baseConfig["FEEDBACK-UI-EXPIRED-MESSAGE"],
  "FEEDBACK-UI-ALREADY-SUBMITTED-MESSAGE":
    process.env.REACT_APP_FEEDBACK_UI_ALREADY_SUBMITTED_MESSAGE ||
    baseConfig["FEEDBACK-UI-ALREADY-SUBMITTED-MESSAGE"],
  "FEEDBACK-UI-ERROR-MESSAGE":
    process.env.REACT_APP_FEEDBACK_UI_ERROR_MESSAGE || baseConfig["FEEDBACK-UI-ERROR-MESSAGE"],
  "FEEDBACK-UI-INPUT-VALIDATION-MESSAGE":
    process.env.REACT_APP_FEEDBACK_UI_INPUT_VALIDATION_MESSAGE ||
    baseConfig["FEEDBACK-UI-INPUT-VALIDATION-MESSAGE"],
  "FEEDBACK-UI-PLAYSTORE-URL":
    process.env.REACT_APP_FEEDBACK_UI_PLAYSTORE_URL || baseConfig["FEEDBACK-UI-PLAYSTORE-URL"],
  "FEEDBACK-UI-APPSTORE-URL":
    process.env.REACT_APP_FEEDBACK_UI_APPSTORE_URL || baseConfig["FEEDBACK-UI-APPSTORE-URL"],
  "GOOGLE-ANALYTICS-ID": process.env.REACT_APP_GOOGLE_ANALYTICS_ID || baseConfig["GOOGLE-ANALYTICS-ID"],
};

export default config;
